import { hideBackdrop, showBackdrop } from '../components/backdrop.js';
import '../vendor/TimedPopup.js';

$(function () {
  const $newsletterPopUp = $("#newsletter-popup");
  if ($newsletterPopUp.length <= 0) return false;

  window.pingInit.showNewsletterPopUp = () => {
    $newsletterPopUp.addClass("timed-popup__visible");
    showBackdrop();
  };

  window.pingInit.hideNewsletterPopUp = () => {
    $newsletterPopUp.removeClass("timed-popup__visible");
    hideBackdrop();
  };

  const $footerNewsletterForm = $("#footer-newsletter-form");

  $footerNewsletterForm.on("submit", function (e) {
    e.preventDefault();

    const footerEmailValue = $("input[name=footer_newsletter_email]").val();
    $newsletterPopUp.find("input[type='email']").val(footerEmailValue);

    window.pingInit.showNewsletterPopUp();
  });

  const $newsletterOpenerButton = $(".newsletter-popup-opener");
  if ($newsletterOpenerButton.length > 0) {
    $newsletterOpenerButton.on("click", function () {
      window.pingInit.showNewsletterPopUp();
    });
  }
});
